<template>
  <div class="sale-scenario" v-if="sale_scenario">
    <span>Ottimo prezzo!</span>
  </div>
</template>

<script>

export default {
  name: 'sale-scenario',

  components: {
  },

  props: {
    sale: Object
  },

  data() {
    return {
    }
  },

  computed: {
    // Check su sale_scenario se contiene valori truthy, escludendo 'package'
    sale_scenario() {
      return this.sale &&
        Object.entries(this.sale)
          .filter(([key]) => key !== 'package')
          .some(([, value]) => Boolean(value))
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .sale-scenario {
    background-color: var(--primary);
    color: $white;
    border-radius: $border-radius;
    padding: 0 $grid-gutter-width / 10;

    &:empty {
      display: none;
    }
  }

</style>